import React from "react";
class Login extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        stage: 'login',
        email: "",
        password: "",
        mfa: "",
        flash: null,
        submitting: false
    };

    this.update_field = this.update_field.bind(this);
    this.submit_login = this.submit_login.bind(this);
    this.redirect_timer = null;

  }

  componentWillUnmount(){
    if (this.redirect_timer) {
      clearTimeout(this.redirect_timer);
    }
  }

  csrf_token(){
    const meta = document.querySelector('meta[name="csrf-token"]');
    return this.props.auth_token || (meta ? meta.content : "");
  }

  update_field(field, value){
    const nextValue = field === 'mfa' ? value.replace(/\D/g, '').slice(0, 6) : value;

    this.setState({
      [field]: nextValue,
      flash: null
    });
  }

  show_flash(type, message){
    this.setState({
      flash: {
        type: type,
        message: message
      }
    });
  }

  redirect_home(){
    this.redirect_timer = setTimeout(() => {
      window.location.assign('/settings');
    }, 1500);
  }

  submit_login(){
    if (this.state.submitting) {
      return;
    }

    if (!this.state.email.trim() || !this.state.password) {
      this.show_flash('danger', 'Email and password are required');
      return;
    }

    if (this.state.stage === 'mfa' && this.state.mfa.length !== 6) {
      this.show_flash('danger', 'Enter the 6 digit MFA code');
      return;
    }

    const payload = {
      email: this.state.email,
      password: this.state.password
    };

    if (this.state.stage === 'mfa') {
      payload.mfa = this.state.mfa;
    }

    this.setState({
      submitting: true,
      flash: null
    });

    fetch('/login', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-csrf-token': this.csrf_token()
      },
      body: JSON.stringify(payload)
    }).then((response) => {
      return response.json().then((json) => ({
        ok: response.ok,
        json: json
      }));
    }).then(({json}) => {
      if (!json.success) {
        this.setState({submitting: false});
        this.show_flash('danger', json.error || 'Unable to log in');
        return;
      }

      if (json.required === 'mfa') {
        this.setState({
          stage: 'mfa',
          mfa: "",
          submitting: false
        });

        if (this.state.stage === 'mfa') {
          this.show_flash('danger', 'MFA code was wrong');
        } else {
          this.show_flash('info', 'Enter your MFA code to continue');
        }
        return;
      }

      this.setState({submitting: false});
      this.show_flash('success', 'Login successful. Redirecting...');
      this.redirect_home();
    }).catch(() => {
      this.setState({submitting: false});
      this.show_flash('danger', 'Unable to log in right now');
    });
  }

  render_flash(){
    if (!this.state.flash) {
      return null;
    }

    return (
      <div className={`psintegril-flash psintegril-flash-${this.state.flash.type}`}>
        <div className="psintegril-flash-content">
          <div className="psintegril-flash-message">{this.state.flash.message}</div>
        </div>
      </div>
    );
  }

  render_login_stage(){
    return (
      <div>
        <h2 className="psintegril-h2">Log in</h2>
        <p className="psintegril-text">Enter your email and password to continue.</p>

        <label className="psintegril-signup-field">
          <span>Email</span>
          <input
            className="psintegril-input"
            type="email"
            autoComplete="email"
            value={this.state.email}
            onChange={(event) => this.update_field('email', event.target.value)}
            onKeyDown={(e) => {e.key === 'Enter' ? this.submit_login() : null}}
          />
        </label>

        <label className="psintegril-signup-field">
          <span>Password</span>
          <input
            className="psintegril-input"
            type="password"
            autoComplete="current-password"
            value={this.state.password}
            onChange={(event) => this.update_field('password', event.target.value)}
            onKeyDown={(e) => {e.key === 'Enter' ? this.submit_login() : null}}
          />
        </label>
      </div>
    );
  }

  render_mfa_stage(){
    return (
      <div>
        <h2 className="psintegril-h2">MFA code</h2>
        <p className="psintegril-text">Enter the 6 digit code from your authenticator app.</p>

        <label className="psintegril-signup-field">
          <span>MFA code</span>
          <input
            className="psintegril-input"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            value={this.state.mfa}
            onChange={(event) => this.update_field('mfa', event.target.value)}
            onKeyDown={(e) => {e.key === 'Enter' ? this.submit_login() : null}}
          />
        </label>
      </div>
    );
  }

  render () {
    return (
        <div className="psintegril-signup">
          <div className="psintegril-card psintegril-signup-card">
            {this.state.stage === 'mfa' ? this.render_mfa_stage() : this.render_login_stage()}
            {this.render_flash()}

            <div className="psintegril-signup-actions">
              {this.state.stage === 'mfa' ? (
                <button
                  className="psintegril-btn psintegril-btn-secondary"
                  type="button"
                  onClick={() => this.setState({stage: 'login', mfa: "", flash: null})}
                >
                  Back
                </button>
              ) : null}

              <button
                className="psintegril-btn psintegril-btn-primary"
                type="button"
                onClick={this.submit_login}
                disabled={this.state.submitting}
              >
                {this.state.submitting ? 'Checking...' : (this.state.stage === 'mfa' ? 'Verify code' : 'Log in')}
              </button>
            </div>
          </div>
        </div>
    );
  }
}

export default Login;
